export class NoChannelAvailableException extends Error {
  name = 'NoChannelAvailableException'
  constructor(message?: string) {
    super(message)

    if (message) {
      this.message = `Connection channel is unavailable for current operation: ${message}`
    }
  }
}

export class InvalidParameterException extends Error {
  name = 'InvalidParameterException'
}

export class ConnectTimeoutException extends Error {
  name = 'ConnectTimeoutException'
}

export class RequestTimeoutException extends Error {
  name = 'RequestTimeoutException'
}

export class HttpAuthorizationException extends Error {
  name = 'HttpAuthorizationException'
}

export class HttpResourceNotFoundException extends Error {
  name = 'HttpResourceNotFoundException'
}

export class HttpServerException extends Error {
  name = 'HttpServerException'
}

export class IoException extends Error {
  name = 'IoException'
}

export class HttpLocalCancelException extends Error {
  name = 'HttpLocalCancelException'
}

export class HttpRemoteCancelException extends Error {
  name = 'HttpRemoteCancelException'
}

export class InvalidAccountAuthorityException extends Error {
  name = 'InvalidAccountAuthorityException'
}

export class InvalidedParameterException extends Error {
  name = 'InvalidedParameterException'
}

export class InvocationException extends Error {
  name = 'InvocationException'
}

// 无法通过重试恢复的异常，抛出该错误
export class UnrecoverableException extends Error {
  name = 'UnrecoverableException'
}
